import { render } from "./UnauthorizedAccess.vue?vue&type=template&id=547239f8&scoped=true"
import script from "./UnauthorizedAccess.vue?vue&type=script&lang=js"
export * from "./UnauthorizedAccess.vue?vue&type=script&lang=js"

import "./UnauthorizedAccess.vue?vue&type=style&index=0&id=547239f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547239f8"]])

export default __exports__